export { default as Img200 } from './processed/200/American-Horror-Story-S1-Murder-House.jpg';
export { default as Img400 } from './processed/400/American-Horror-Story-S1-Murder-House.jpg';
export { default as Imgthumb } from './processed/thumb/American-Horror-Story-S1-Murder-House.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/American-Horror-Story-S1-Murder-House.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/American-Horror-Story-S1-Murder-House.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      229,
      26,
      45
    ],
    "_population": 0
  },
  "LightVibrant": {
    "_rgb": [
      233,
      230,
      204
    ],
    "_population": 3,
    "_hsl": [
      0.1494252873563219,
      0.3972602739726024,
      0.8568627450980393
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      97,
      11,
      19
    ],
    "_population": 7259,
    "_hsl": [
      0.9844961240310077,
      0.7962962962962963,
      0.21176470588235294
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      148,
      116
    ],
    "_population": 1,
    "_hsl": [
      0.13333333333333333,
      0.16806722689075634,
      0.5333333333333333
    ]
  },
  "LightMuted": {
    "_rgb": [
      201,
      180,
      188
    ],
    "_population": 6,
    "_hsl": [
      0.9365079365079364,
      0.16279069767441845,
      0.7470588235294118
    ]
  },
  "DarkMuted": {
    "_rgb": [
      84,
      76,
      52
    ],
    "_population": 1,
    "_hsl": [
      0.125,
      0.23529411764705882,
      0.26666666666666666
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/American-Horror-Story-S1-Murder-House.js